import { BzgModalRef } from 'bz-genome-angular';
import { Component } from '@angular/core';


@Component({
  selector: 'change-administrator-dialog',
  templateUrl: './change-administrator-dialog.component.html',
  styleUrls: ['../change-administrator.component.scss']
})
export class ChangeAdministratorDialogComponent  {
  public administratorUserName: string;
  public EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;

  constructor(public modalComponentRef: BzgModalRef) { }

  public close() {
    this.modalComponentRef.close();
  }
  public isValidEmail() {
    return this.administratorUserName.match(this.EMAIL_REGEXP);
  }
  public change() {
    this.modalComponentRef.close({userName: this.administratorUserName});
  }
}
